import { ID, Task } from '@griply/types';

import { taskGoalIds, taskLifeAreaIds } from '../links/task-link-ids';

export type ApplyReorderTaskLinksOptions = {
  task: Task;
  original: Task;
  goalIds?: ID[];
  lifeAreaIds?: ID[];
};

// Writes the link arrays onto the cloned task the caller is about to submit; the scalars
// trail as the first entry so older clients keep resolving their link.
export const applyReorderTaskLinks = ({
  task,
  original,
  goalIds,
  lifeAreaIds,
}: ApplyReorderTaskLinksOptions): void => {
  const currentGoalIds = taskGoalIds(original);
  const currentLifeAreaIds = taskLifeAreaIds(original);

  const nextGoalIds = goalIds ?? currentGoalIds;
  const nextLifeAreaIds = lifeAreaIds ?? currentLifeAreaIds;

  task.goalIds = nextGoalIds;
  task.lifeAreaIds = nextLifeAreaIds;
  task.goalId = nextGoalIds[0] ?? null;
  task.lifeAreaId = nextLifeAreaIds[0] ?? null;
};
